import React, { useState, useContext } from "react";
import Footer from "../../component/Footer";
import Navbar from "../../component/Navbar";
import { Link } from "react-router-dom";
import { UserContext } from "../../App";

import SideBar from "./SideBar";
import Arrow from "../Arrow";
import Generalsidebar from "../Generalsidebar";

function Profile() {
  const { userInfo: userData, setUserInfo } = useContext(UserContext);
  const [showSidebar, setShowSidebar] = useState(false);
  const [isTriggered, setIsTiggered] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("userLoggedIn"))
    ? JSON.parse(localStorage.getItem("userLoggedIn"))
    : { firstName: "" };

  console.log("userInfo", userInfo);
  function handleArrowClick() {
    // setIsTiggered(true);
    setShowSidebar(true);
  }

  return (
    <div className="bg-[#D9D9D9]">
      <Navbar />
      <div onClick={handleArrowClick} className="absolute top-24 left-12 z-20">
        <Arrow />
      </div>
      <div className={showSidebar ? "show-sidebar" : "hidden"}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <section className="flex min-h-[80vh] md:min-h-[100vh]">
        {/* <SideBar /> */}
        <section className="flex flex-1 flex-col items-center gap-4 pt-20">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrBp4rAadRiXmk6NWl3redkvGJgWGDkBT4vA&usqp=CAU"
            alt=""
            className="w-20 h-20 rounded-full md:w-28 md:h-28 object-cover"
          />
          <h1 className="  uppercase text-xl font-semibold">About Me</h1>
          <p
            className=" flex justify-center items-center  text-center max-w-[50%] mx-auto text-xl "
            id="update-about"
          >
            Hi, I am {userInfo.firstName}.
          </p>
          <Link to="/settingsprofile">
            <button className=" bg-[#295700] text-white px-4 py-2 rounded-sm relative  mt-8 md:relative right-0 md:mt-16">
              EDIT PROFILE
            </button>
          </Link>
        </section>
      </section>
      <Footer />
    </div>
  );
}

export default Profile;
